<div class="action edit" (click)="onEditClicked()">
  <ion-icon name="create"></ion-icon>
</div>